var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Navbar"},[_c('mu-appbar',{staticStyle:{"width":"100%"},attrs:{"title":"郑煤机集团科技文化展示中心","color":"primary"}},[_c('mu-button',{attrs:{"slot":"right","flat":""},on:{"click":_vm.Refrash},slot:"right"},[_c('mu-icon',{attrs:{"value":"autorenew","color":"#ffffff"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9f983b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/BookPage/components/Navbar.vue
// module id = null
// module chunks = 